import { render, staticRenderFns } from "./messenger.vue?vue&type=template&id=5c6f6954&scoped=true"
import script from "./messenger.vue?vue&type=script&lang=js"
export * from "./messenger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6f6954",
  null
  
)

export default component.exports